// Form validation utilities

export const validators = {
    // Email validation
    isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    },

    // Phone validation
    isValidPhone(phone) {
        const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
        return phoneRegex.test(phone);
    },

    // Password strength
    isStrongPassword(password) {
        // At least 8 characters, 1 uppercase, 1 lowercase, 1 number
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*?&]{8,}$/;
        return passwordRegex.test(password);
    },

    // Required field
    isRequired(value) {
        return value !== null && value !== undefined && value.toString().trim() !== '';
    },

    // Min length
    minLength(value, min) {
        return value && value.length >= min;
    },

    // Max length
    maxLength(value, max) {
        return value && value.length <= max;
    },

    // Validate form
    validateForm(fields, rules) {
        const errors = {};

        Object.keys(rules).forEach(fieldName => {
            const fieldRules = rules[fieldName];
            const fieldValue = fields[fieldName];

            fieldRules.forEach(rule => {
                if (rule.type === 'required' && !this.isRequired(fieldValue)) {
                    errors[fieldName] = rule.message || 'This field is required';
                }
                else if (rule.type === 'email' && fieldValue && !this.isValidEmail(fieldValue)) {
                    errors[fieldName] = rule.message || 'Invalid email address';
                }
                else if (rule.type === 'phone' && fieldValue && !this.isValidPhone(fieldValue)) {
                    errors[fieldName] = rule.message || 'Invalid phone number';
                }
                else if (rule.type === 'password' && fieldValue && !this.isStrongPassword(fieldValue)) {
                    errors[fieldName] = rule.message || 'Password must be at least 8 characters with uppercase, lowercase, and number';
                }
                else if (rule.type === 'minLength' && fieldValue && !this.minLength(fieldValue, rule.value)) {
                    errors[fieldName] = rule.message || `Minimum ${rule.value} characters required`;
                }
                else if (rule.type === 'maxLength' && fieldValue && !this.maxLength(fieldValue, rule.value)) {
                    errors[fieldName] = rule.message || `Maximum ${rule.value} characters allowed`;
                }
            });
        });

        return {
            isValid: Object.keys(errors).length === 0,
            errors
        };
    }
};

export default validators;
